import React from 'react'
import PropTypes from 'prop-types'

import Banner from '../Banner'

export const ErrorView = ({ error, title, pageName, text }) => {
  return (
    <Banner
      inline
      type='warning'
    >
      <h2>{title} Loading Error</h2>
      {text && <p>{text}</p>}

      <p>
        There was an error loading the {pageName} page. Please refresh the page to retry.
      </p>

      <pre>
        {error.message}

        {error.stack}
      </pre>
    </Banner>
  )
}

ErrorView.propTypes = {
  /**
   * Standard javascript stack error format.
   * Pass whatever you get back from JS.
   */
  error: PropTypes.object,
  /**
   * Shows as a headline
   */
  title: PropTypes.string,
  /**
   * The user-facing name of the page.
   * Example: 'Wallet', 'products
   */
  pageName: PropTypes.string,
  /**
   * Optional text to show
   */
  text: PropTypes.string
}

ErrorView.defaultProps = {
  title: '',
  pageName: ''
}

export default ErrorView
